import CustomConfirmationDialog from '../../../../DriverPopUp/common/CustomConfirmationDialog';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core';
import { useState, useEffect } from 'react';
import Events from '../../../../../../../../utilities/EventEmitter';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  recommendationUpdateLabel: {
    display: 'flex',
    color: theme.warningTextColorDispatch,
    paddingTop: 20
  },
  warningIconClass: { color: theme.warningTextColor, paddingRight: '10px' }
});

const RecommendationConfirmationDialog = ({
  title,
  description,
  onCancel,
  onConfirm,
  classes,
  isInValidSelection
}) => {
  const [isNewRecommendationAvailable, setNewRecommendationAvailable] = useState(false);
  useEffect(() => {
    Events.on('SelectedRecommendationChanged', onSelectedRecommendationChange);
    return () => {
      Events.off('SelectedRecommendationChanged', onSelectedRecommendationChange);
    };
  }, [isNewRecommendationAvailable]);
  const onSelectedRecommendationChange = () => {
    setNewRecommendationAvailable(true);
  };

  return (
    <CustomConfirmationDialog
      title={title}
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Yes"
      onConfirm={onConfirm}
      disabled={isInValidSelection}
      onCancel={onCancel}>
      <div className={classes.container}>
        {description}
        {isNewRecommendationAvailable && (
          <span className={classes.recommendationUpdateLabel}>
            <WarningIcon aria-label="Warning" className={classes.warningIconClass} />
            Recommendation got updated, are you sure you want to continue?
          </span>
        )}
      </div>
    </CustomConfirmationDialog>
  );
};

export default withStyles(styles)(RecommendationConfirmationDialog);
